import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import { ThemeProvider } from "@material-ui/styles";
import actionBarTheme from "../themes/actionBarTheme";
import { toCamelCase } from "@defi/core-utils";
var useStyles = makeStyles(function (theme) {
  return {
    actionBar: {
      width: "100%",
      // backgroundColor: '#f5f5f5',
      position: "fixed",
      bottom: 0,
      margin: 0,
      padding: 0
    },
    flexer: {
      flex: "1 1 auto"
    },
    button: {
      height: 64,
      borderRadius: 0,
      boxShadow: "none",
      fontSize: 14,
      minWidth: 105
    }
  };
});

function DefiActionBar(props) {
  var classes = useStyles();
  var children = props.children;
  return React.createElement(ThemeProvider, {
    theme: actionBarTheme
  }, React.createElement(Toolbar, {
    className: classes.actionBar,
    "data-testid": "toolbar"
  }, React.createElement("div", {
    className: classes.flexer
  }), children && children.map(function (action, i) {
    return React.createElement(Button, {
      key: i,
      variant: "contained",
      color: action.color,
      className: classes.button,
      onClick: action.onClick,
      disabled: action.disabled,
      "data-test": action.testName ? action.testName : toCamelCase(action.name) + "Button",
      "data-testid": "button-".concat(i)
    }, action.name);
  })));
}

export default DefiActionBar;